import React from "react";
import PageContainerAuth from "../../components/common/PageContainerAuth";
import MediaSection from "../../components/pages/media/MediaSection";

export function Media() {

    return (
        <PageContainerAuth section="mailings-media" pageTitle="Média">
            <MediaSection />
        </PageContainerAuth>
    );
}